/*
  SylverCar — page de liste du blog : filtre par pilier et devoilement par lot.

  Ce script n'ajoute pas une fonction, il en ameliore une qui existe deja.

  Sans lui, chaque pastille reste un lien vers l'URL de tag Shopify et la page
  se rend filtree par le serveur : le filtre fonctionne, il coute juste un
  rechargement. Le script intercepte le clic pour l'eviter, et met l'URL a
  jour pour que le partage et le bouton Retour restent justes.

  Aucun article n'est jamais absent du HTML : le masquage se fait sur des
  cartes deja rendues. Rien n'echappe donc a l'indexation.
*/
(function () {
  'use strict';

  var PILIERS = ['confort', 'organisation', 'ambiance'];

  function demarrer() {
    var bloc = document.querySelector('[data-sc-blog]');
    if (!bloc) return;

    var pastilles = bloc.querySelectorAll('[data-sc-filtre]');
    var cartes = Array.prototype.slice.call(bloc.querySelectorAll('[data-sc-carte]'));
    var vedette = bloc.querySelector('[data-sc-vedette]');
    var bouton = bloc.querySelector('[data-sc-voir-plus]');
    var lienPageSuivante = bloc.querySelector('[data-sc-page-suivante]');
    var lot = parseInt(bloc.getAttribute('data-lot'), 10) || 9;

    var vue = bloc.getAttribute('data-vue') || 'tous';
    var reveles = lot;

    function correspond(el) {
      return vue === 'tous' || el.getAttribute('data-pilier') === vue;
    }

    function rendre() {
      var vus = 0;
      var restants = 0;

      for (var i = 0; i < cartes.length; i++) {
        var carte = cartes[i];
        if (!correspond(carte)) {
          carte.classList.add('est--repliee');
          continue;
        }
        if (vus < reveles) {
          carte.classList.remove('est--repliee');
          vus++;
        } else {
          carte.classList.add('est--repliee');
          restants++;
        }
      }

      // La vedette n'appartient qu'a un pilier : elle s'efface quand on en
      // consulte un autre, plutot que de coiffer une liste a laquelle elle
      // n'appartient pas.
      if (vedette) vedette.classList.toggle('est--repliee', !correspond(vedette));

      if (bouton) bouton.hidden = restants === 0;
      // Le lien vers la page suivante n'a de sens qu'une fois cette page
      // epuisee, et seulement sans filtre : une URL de tag a sa propre
      // pagination.
      if (lienPageSuivante) {
        lienPageSuivante.hidden = restants > 0 || vue !== 'tous';
      }
    }

    function filtrer(nouvelle, url) {
      if (nouvelle !== 'tous' && PILIERS.indexOf(nouvelle) < 0) return;
      vue = nouvelle;
      reveles = lot;
      bloc.setAttribute('data-vue', vue);

      for (var i = 0; i < pastilles.length; i++) {
        var active = pastilles[i].getAttribute('data-sc-filtre') === vue;
        pastilles[i].classList.toggle('est--active', active);
        if (active) pastilles[i].setAttribute('aria-current', 'true');
        else pastilles[i].removeAttribute('aria-current');
      }

      rendre();

      if (url && window.history && window.history.pushState) {
        window.history.pushState({ scBlogVue: vue }, '', url);
      }
    }

    for (var i = 0; i < pastilles.length; i++) {
      pastilles[i].addEventListener('click', function (e) {
        e.preventDefault();
        filtrer(this.getAttribute('data-sc-filtre'), this.getAttribute('href'));
      });
    }

    if (bouton) {
      bouton.addEventListener('click', function () {
        reveles += lot;
        rendre();
      });
    }

    // Bouton Retour du navigateur : on repasse a la vue que porte l'URL,
    // sans recharger.
    window.addEventListener('popstate', function () {
      var trouvee = 'tous';
      for (var j = 0; j < PILIERS.length; j++) {
        if (location.pathname.indexOf('/tagged/pilier-' + PILIERS[j]) >= 0) trouvee = PILIERS[j];
      }
      filtrer(trouvee, null);
    });

    rendre();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
